import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { CancellationPolicy } from './CancellationPolicy'

export const ListOfCancellationPolicyValidation = z.object({
  list: z
    .instanceof(CancellationPolicy, { message: '[ListOfCancellationPolicy] list is required' })
    .array(),
})

export class ListOfCancellationPolicy extends Model {
  static create({ list }: z.infer<typeof ListOfCancellationPolicyValidation>) {
    ListOfCancellationPolicyValidation.parse({ list })
    return new ListOfCancellationPolicy(list)
  }

  static fromJSON({ json }: { json: ReturnType<ListOfCancellationPolicy['toJSON']> }) {
    return ListOfCancellationPolicy.create({
      list: json.list.map(cancellationPolicyJSON =>
        CancellationPolicy.fromJSON({ json: cancellationPolicyJSON })
      ),
    })
  }

  static empty() {
    return new ListOfCancellationPolicy([])
  }

  constructor(private readonly _list: CancellationPolicy[]) {
    super()
  }

  get list() {
    return this._list
  }

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  isEmpty() {
    return this._list.length === 0
  }

  map<T>(callback: (cancellationPolicy: CancellationPolicy) => T) {
    return this._list.map(callback)
  }
}
